import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { api, errorText, post } from '../../lib/api';
import { Avatar, LogoMark } from '../../ui/primitives';
import './login.css';

// 手机微信里的确认页：扫码后服务号消息里的“点这里确认登录”打开这里（设计稿 25c 的手机端）

interface Info {
  needOAuth: boolean;
  oauthUrl?: string;
  status?: string;
  member?: { name: string; initial: string; teamName: string | null } | null;
}

export function WxConfirmPage() {
  const [params] = useSearchParams();
  const t = params.get('t') ?? '';
  const [info, setInfo] = useState<Info | null>(null);
  const [result, setResult] = useState<'allowed' | 'denied' | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api<Info>(`/auth/wx/confirm-info?t=${encodeURIComponent(t)}`)
      .then((r) => {
        if (r.needOAuth && r.oauthUrl) location.href = r.oauthUrl;
        else setInfo(r);
      })
      .catch((e) => setError(errorText(e)));
  }, [t]);

  const decide = async (allow: boolean) => {
    setBusy(true);
    try {
      await post('/auth/wx/confirm', { t, allow });
      setResult(allow ? 'allowed' : 'denied');
    } catch (e) {
      setError(errorText(e));
    } finally {
      setBusy(false);
    }
  };

  const stale = info && info.status !== 'scanned' && !result;
  return (
    <div className="wxc">
      <LogoMark size={40} />
      <div style={{ width: '100%', maxWidth: 360, marginTop: 28 }}>
        {result === 'allowed' ? (
          <>
            <h1 className="lg-title">已确认</h1>
            <p className="lg-desc">回到电脑上继续，可以关闭这个页面了。</p>
          </>
        ) : result === 'denied' ? (
          <>
            <h1 className="lg-title">已取消这次登录</h1>
            <p className="lg-desc">如果不是你本人在扫码，说明有人拿到了登录二维码，留意一下就好。</p>
          </>
        ) : error || stale ? (
          <>
            <h1 className="lg-title">这个登录请求已经失效</h1>
            <p className="lg-desc">{error ?? '请在电脑上刷新二维码后重新扫码。'}</p>
          </>
        ) : !info ? (
          <p className="lg-desc">正在确认身份…</p>
        ) : (
          <>
            <h1 className="lg-title">在电脑上登录 Wattsonic 日报？</h1>
            <p className="lg-desc">确认是你本人在电脑前扫码。</p>
            {info.member && (
              <div className="lg-person" style={{ marginTop: 24 }}>
                <Avatar initial={info.member.initial} seed={info.member.name} size={32} />
                <div className="col flex1" style={{ gap: 2 }}>
                  <span className="c1" style={{ fontSize: 15 }}>
                    {info.member.name}
                  </span>
                  <span className="t-meta">{[info.member.teamName, 'Wattsonic'].filter(Boolean).join(' · ')}</span>
                </div>
              </div>
            )}
            <div className="lg-actions">
              <button type="button" className="lg-btn primary" disabled={busy} onClick={() => void decide(true)}>
                允许
              </button>
              <button type="button" className="lg-btn ghost" disabled={busy} onClick={() => void decide(false)}>
                不是我，取消
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
